import React, { useState, useCallback, useEffect } from "react";
import { Field, Formik, Form, ErrorMessage } from "formik";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import { DialogActions, DialogContent } from "@mui/material";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import { toast } from "react-toastify";
import { indicatorSchema } from "../../validations/IndicatorValidation";
import {
  updateIndicator,
  getIndicators,
  createIndicator,
} from "../../services/indicatorServices";

export default function IndicatorModalForm({
  setIndicators,
  id,
  open,
  setOpen,
  title,
  initialValues,
  edit,
  indicatorId,
  setFormEdit,
  setIndicatorsError,
}) {
  
  

  const handleClickOpen = () => {
    setOpen(true);
    setFormEdit(false);
  };

  const handleClose = () => {
    setOpen(false);
    setFormEdit(false);
  };

  const indicatorsList = useCallback(async () => {
    try {
      const response = await getIndicators(id);
      setIndicators(response.data);
    } catch (err) {
      if (!err?.response) {
        
      }
    }
  }, []);

  const onSubmit = async (data, { resetForm }) => {
    if (edit) {
      try {
        const response = await updateIndicator(indicatorId, id, data);
        handleClose();
        toast.success(
          `Se ha agregado el nuevo indicador ${response.data.name}`
        );
        indicatorsList();
      } catch (err) {
        if (!err?.response) {
          toast.error("No responde el servidor");
        } else {
          toast.error(err.response.data.error);
        }
      }
    } else {
      
      try {
        const response = await createIndicator(id, data);
        handleClose();
        
        toast.success(
          `Se ha agregado el nuevo indicador ${response.data.name}`
        );
        indicatorsList();
        setIndicatorsError(false);
      } catch (err) {
        
        if (!err?.response) {
          toast.error("No responde el servidor");
        } else {
          toast.error(err.response.data.error);
        }
      }
    }
    resetForm();
  };

  return (
    <>
      <Grid item sx={{ paddingLeft: 8, paddingTop: 3 }} xs={12}>
        <Button variant="outlined" onClick={handleClickOpen}>
          Agregar indicador
        </Button>
      </Grid>

      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={indicatorSchema}
        validateOnBlur={false}
        enableReinitialize={true}
      >
        {(props) => (
          <Dialog open={open} onClose={handleClose}>
            <Form>
              <DialogTitle>{title}</DialogTitle>
              <DialogContent>
                <Grid container direction="row" spacing={2} sx={{ mt: "5px" }}>
                  <Grid item xs={12}>
                    <TextField
                      select
                      fullWidth
                      label="Estado"
                      placeholder="Estado"
                      name="status"
                      variant="outlined"
                      value={props.values?.status}
                      onChange={(e) => {
                        props.setFieldValue("status", e.target.value);
                      }}
                      error={!!props?.errors?.status && props?.touched?.status}
                      helperText={<ErrorMessage name="status" />}
                      autoFocus
                    >
                      <MenuItem value="executed">Ejecutado</MenuItem>
                      <MenuItem value="unexecuted">No Ejecutado</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item xs={12}>
                    <Field
                      as={TextField}
                      name="name"
                      type="text"
                      fullWidth
                      label="Indicador"
                      placeholder="Indicador"
                      variant="outlined"
                      value={props.values?.name}
                      error={!!props?.errors?.name && props?.touched?.name}
                      helperText={<ErrorMessage name="name" />}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Field
                      as={TextField}
                      name="description"
                      type="text"
                      fullWidth
                      label="Observaciones/Descripciones"
                      placeholder="Observaciones/Descripciones"
                      variant="outlined"
                      value={props.values?.description}
                      error={
                        !!props?.errors?.description &&
                        props?.touched?.description
                      }
                      helperText={<ErrorMessage name="description" />}
                    />
                  </Grid>
                </Grid>
              </DialogContent>

              <DialogActions>
                <Button variant="contained" type="submit">
                  Guardar
                </Button>
                <Button variant="outlined" onClick={handleClose}>
                  Cancelar
                </Button>
              </DialogActions>
            </Form>
          </Dialog>
        )}
      </Formik>
    </>
  );
}
